// extracted by mini-css-extract-plugin
module.exports = {"insightsIconContainer":"FiZkLbak","scenarioIconWrapper":"gR0yzDIj"};